import { Avatar, AvatarFallback } from '@/components/ui/shadcn/avatar'
import { cn } from '@/lib/utils'
import { sourceName, type AutomationSource } from './source'

interface Props {
  source: AutomationSource
  size?: 'sm' | 'md'
  showName?: boolean
  className?: string
}

/**
 * An automation's content source: initial avatar + name. Used in rows, the
 * dialog select, and the flow canvas.
 */
export function SourceChip({ source, size = 'md', showName = true, className }: Props) {
  const name = sourceName(source)
  const initial = name.charAt(0).toUpperCase()
  const dim = size === 'sm' ? 'h-6 w-6' : 'h-7 w-7'

  return (
    <span className={cn('flex min-w-0 items-center gap-2', className)}>
      <Avatar className={dim}>
        <AvatarFallback className="text-foreground text-[10px] font-semibold">
          {initial}
        </AvatarFallback>
      </Avatar>
      {showName && (
        <span
          className={cn(
            'text-foreground truncate font-medium',
            size === 'sm' ? 'text-xs' : 'text-sm',
          )}>
          {name}
        </span>
      )}
    </span>
  )
}
